import '../../common/bn-action';
import '../../common/bn-card';
import '../../common/bn-flash';
import '../../common/bn-loading';
import { html, css, LitEntity, SirenActionMixin } from '../../utility/lit-entity';
import { sharedStyles } from '../../styles/shared-styles';

class LocationDelegate extends SirenActionMixin(LitEntity) {
  constructor() {
    super();
    this.partners = [];
  }

  static get properties() {
    return {
      partners: { type: Array, attribute: false },
      selectedPartnerHref: { type: String, attribute: false },
      isFetching: { type: Boolean, attribute: false },
      isSubmitting: { type: Boolean, attribute: false },
    };
  }

  static get styles() {
    return [sharedStyles, css`
      bn-card:hover {
        cursor: pointer;
        --card-background-color: var(--yellow-10);
      }
      bn-card[selected] {
        cursor: pointer;
        --card-background-color: var(--blue-40);
        --card-border-color: var(--blue-60);
      }
      .actions {
        margin-top: 1rem;
      }
    `];
  }

  render() {
    const disableSubmit = this.isSubmitting || this.isFetching || !this.selectedPartnerHref;
    return html`
      <p>
        Delegate work order location to...
      </p>

      <div class="partners">
        ${this._renderPartners()}
      </div>

      <bn-flash></bn-flash>

      <div class="actions">
        <button class="button button--contained" @click="${this._delegate}" ?disabled="${disableSubmit}">
          Delegate
        </button>
      </div>
    `;
  }

  _renderPartners() {
    if (this.isFetching) {
      return html`<bn-loading></bn-loading>`;
    }
    return this.partners.map(p => html`
      <bn-card
        class="partner"
        ?selected="${this.selectedPartnerHref === p.getLink('self').href}"
        @click="${() => this.selectedPartnerHref = p.getLink('self').href}"
      >
        ${p.properties.name}
      </bn-card>
    `);
  }

  async _entityChanged(entity) {
    super._entityChanged(entity);
    if (!this.entity) {
      return;
    }

    this.isFetching = true;

    const farm = await this.fetchSiren(this.getHref('https://api.binsentry.com/rel/farm'));
    const ancestors = await this.fetchSiren(this.getHref('https://api.binsentry.com/rel/organization-ancestors', farm));
    const account = ancestors.getSubEntitiesByClass('organization').find((org) => org.getSubEntityByRel('https://api.binsentry.com/rel/organization-type').properties.name === 'account');
    const relatedOrgs = await this.fetchSiren(this.getHref('https://api.binsentry.com/rel/related-organizations', account));

    this.isFetching = false;

    this.partners = relatedOrgs.getSubEntitiesByRel('https://api.binsentry.com/rel/service-partner').map((e) => e.getSubEntityByClass('organization'));

    if (this.partners.length === 1) {
      this.selectedPartnerHref = this.partners[0].getLink('self').href;
    }
  }

  async _delegate() {
    this.isSubmitting = true;
    const flash = this.shadowRoot.querySelector('bn-flash');
    flash.clear();
    const action = this.entity.getAction('delegate-partner');
    action.getField('servicePartnerId').value = this.selectedPartnerHref;
    const { entity, response, error } = await this.submitAction(action);
    this.isSubmitting = false;
    if (error) {
      flash.error(`Failed to delegate work order location to partner. <div><code>${error.message}</code></div>`);
      this.dispatchEvent(new ErrorEvent('error', { error, bubbles: true, composed: true }));
      return;
    }
    this.dispatchEvent(new CustomEvent('response', { detail: { entity, response }, bubbles: true, composed: true }));
  }
}

window.customElements.define('location-delegate', LocationDelegate);
